import { FieldTypes } from '../../../constants/FieldTypes'
import { DropdownField, Field, FieldMap, InfoStage } from '../../../types/forms/fields'
import { selectCoverageOption } from './utils'

export const noCoverageDescriptionField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  condition: selectCoverageOption('no-coverage'),
  placeholder: 'Please specify...',
  options: [
    { text: 'I want to pay out of pocket', id: 'out-of-pocket' },
    { text: 'I need advice on obtaining coverage', id: 'need-advice' },
  ],
}

export const noCoverageFields: Record<string, Field | InfoStage> = {
  noCoverageDescription: noCoverageDescriptionField,
}

export const noCoverageField: FieldMap = {
  name: 'Please specify',
  children: noCoverageFields,
}
